/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deactivateAccount.defs.js'
export * as $defs from './deactivateAccount.defs.js'
